import { StyleSheet } from "react-native";
import { ScrollView } from "react-native-gesture-handler";
import CourseCard from "../CourseCard/CourseCard";

function CourseCardList({ courses = [], onPress }) {
  return (
    <ScrollView
      role="list"
      accessibilityRole="list"
      horizontal={true}
      height={234}
      showsHorizontalScrollIndicator={true}
      style={styles.scrollView}
      tabIndex={0}>
      {courses.map((course) => {
        const handleCoursePress = typeof onPress === "function" ? () => onPress(course.id) : undefined;

        return (
          <CourseCard
            key={course.id}
            title={course?.title}
            description={course?.description}
            fillPercentage={course?.fillPercentage}
            label={course?.label}
            onPress={handleCoursePress}
          />
        );
      })}
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});

export default CourseCardList;
